// extracted by mini-css-extract-plugin
export default {"SingleColumnTemplate":"SingleColumnTemplate_SingleColumnTemplate__HN-bW","SingleColumnTemplate__Body":"SingleColumnTemplate_SingleColumnTemplate__Body__pS6ka"};